import React from "react";

const Bash_Ownership = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Ownership</h2>
      <p>Files have an owner and a group. Use <code>ls -l</code> to view. Ownership determines who can read/write/execute files.</p>
    </div>
  );
};

export default Bash_Ownership;
